// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import RibbonController from "./ribbon_controller"
application.register("ribbon", RibbonController)
